<div class="image">
    <img
        *ngIf="imageSource"
        [ngSrc]="imageSource | compressFilePickerImage: 500"
        vpgImage
        priority
        fill
        [alt]="imageAlternativeText"
        class="card-image"
        id="{{ id }}-image'"
        showDefaultImageOnError />
    <ng-container [ngTemplateOutlet]="imageTemplate"></ng-container>
</div>
<div class="info">
    <ng-container [ngTemplateOutlet]="statusTemplate"></ng-container>
    <genesis-frontend-dynamic-heading
        [level]="headingLevel"
        [content]="title"
        [className]="'card-title h4'"
        id="{{ id }}-title"
        [describedBy]="moduleReward.showReward ? (id ? id + '-reward-text' : 'reward-text') : ''"></genesis-frontend-dynamic-heading>

    <span
        id="{{ id }}-subtitle"
        *ngIf="subTitle"
        class="card-subtitle block body-regular">
        {{ subTitle }}
    </span>

    <genesis-frontend-homepage-module-reward
        #moduleReward="moduleReward"
        aria-hidden="true"
        class="mt-sm"
        [id]="rewardRibbonId"
        [rewardableActionType]="rewardableActionType"
        [eventCode]="rewardEventCode" />

    <span
        *ngIf="moduleReward.showReward"
        id="{{ id }}-reward-text"
        class="sr-only"
        aria-hidden="true">
        {{ moduleReward.rewardText }}
    </span>

    <div
        anchorWcag
        class="card-text"
        id="{{ id }}-text"
        [innerHtml]="text | accessibleHTML"></div>

    <ng-container [ngTemplateOutlet]="infoTemplate"></ng-container>
</div>
<div
    class="actions"
    id="{{ id }}-actions">
    <ng-container [ngTemplateOutlet]="actionsTemplate"></ng-container>
</div>
